<template>
  <div>
    <el-dialog
      class="crm-import-dialog"
      width="680px"
      center
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        class="crm-import-dialog-form"
        ref="form"
        :label-position="labelPosition"
        label-width="80px"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="1. 请按照模板格式准备需要导入的数据">
          <i class="iconfont iconxiazai1" style="font-size:24px;vertical-align: middle"></i>
          <ExportExcelComponent :list="list" :title="'下载客户列表导入模板'" />
        </el-form-item>
        <el-form-item label="2. 请选择需要导入的文件" prop="uploadfile" class="crm-form-file">
          <upload-excel-component
            ref="uploadExcel"
            :selectedType="selectedType"
            @uploadFile="uploadFile"
            @beforeUpload="beforeUpload"
          />
        </el-form-item>
        <el-form-item prop="selected" class="crm-form-select">
          <el-select v-model="form.selected" placeholder="请选择客户属性">
            <el-option
              v-for="item in inputOptions"
              :key="item.id"
              :label="item.val"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="handleImport">开始导入</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="crm-import-result-dialog"
      width="480px"
      center
      :visible.sync="importDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      @close="handleCloseResult"
    >
      <div class="crm-import-result">
        <h1 :class="isImportSuccess?'text-success':'text-error'">
          <i class="iconfont" :class="isImportSuccess? 'iconchenggong': 'iconshibai'"></i>
          <span>{{ promptMsg.title }}</span>
        </h1>
        <p v-if="isImportSuccess">
          本次共导入
          <span class="text-success">{{ promptMsg.content }}</span>条客户数据
        </p>
        <p v-else-if="showDownload">
          本次
          <span class="text-error">{{ promptMsg.content }}</span>条客户数据错误
          <ExportExcelComponent :list="list" :title="'错误文件下载'" :errFileName="errFileName" />
        </p>
        <p v-else-if="!showDownload" class="text-error">{{ promptMsg.content }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseResult ">取消</el-button>
        <el-button type="primary" size="small" @click="handleCloseResult(promptMsg)">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadExcelComponent from '@/components/UploadExcel'
import ExportExcelComponent from '@/components/ExportExcel'
import { getCustomerField } from '@/api/crm/clientInfo'
export default {
  components: { UploadExcelComponent, ExportExcelComponent },
  data() {
    const validEmpty = (rule, value, callback) => {
      // console.log('value', value)

      if (!value) {
        callback(new Error('请先选择文件'))
      } else if (value && !(value / 1024 / 1024 < 2)) {
        callback(new Error('文件大小不能大于2M'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: true,
      importDialogVisible: false,
      dialogTitle: '客户列表导入',
      labelPosition: 'top',
      form: { selected: '' },
      // 子选项-【输入框】的下拉列表
      inputOptions: [],
      list: [],
      promptMsg: { title: '', content: '' },
      clientList: [],
      selectedType: '',
      isImportSuccess: false,
      showDownload: false,
      errFileName: '',
      rules: {
        selected: [
          {
            required: true,
            message: '请选择客户属性',
            trigger: ['blur', 'change']
          }
        ],
        uploadfile: [
          {
            validator: validEmpty,
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    const option = {
      tag: 'customer_property'
    }
    getCustomerField(option).then(res => {
      this.inputOptions = res.data[0].fieldValues
    })
  },
  watch: {
    'form.selected'(val, old) {
      this.selectedType = val
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeImportDialog')
    },
    // 关闭结果展示弹框，清除文件列表，表单校验设置为null
    handleCloseResult(promptMsg) {
      this.importDialogVisible = false
      this.$refs.uploadExcel.fileList = []
      this.$set(this.form, 'uploadfile', null)
      if (promptMsg.title && promptMsg.title === '导入成功') {
        this.handleClose()
      }
    },
    // 校验通过，开始导入
    handleImport() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$refs.uploadExcel.doSubmit()
        }
      })
    },
    // 表单提交成功，结果展示
    uploadFile(data) {
      this.importDialogVisible = true
      this.showDownload = false
      this.isImportSuccess = data.msg.indexOf('导入成功') > -1
      if (this.isImportSuccess) {
        // 导入成功
        this.$set(this.promptMsg, 'title', '导入成功')
        this.$set(this.promptMsg, 'content', data.successCount)
      } else {
        this.$set(this.promptMsg, 'title', '导入失败')
        if (data.errFileName) {
          // 导入有错误文件需要下载
          this.showDownload = true
          this.errFileName = data.errFileName
          this.$set(this.promptMsg, 'content', data.errCount)
        } else {
          // 导入失败无错误文件
          this.$set(this.promptMsg, 'content', data.msg)
        }
      }
    },
    // 给表单赋值进行非空和文件大小校验
    beforeUpload(file, fileList) {
      if (fileList && fileList.length > 0) {
        this.$set(this.form, 'uploadfile', file.size)
      } else {
        this.$set(this.form, 'uploadfile', null)
      }
    }
  }
}
</script>
<style lang="scss">
.text-success {
  color: #4abe49;
}
.text-error {
  color: #f56c6c;
}
.crm-import-result .crm-export {
  margin-top: 20px;
}
.crm-import-result {
  text-align: center;
  h1 {
    font-size: 20px;
    font-weight: 400;
    line-height: 50px;
    margin-bottom: 30px;
    i {
      font-size: 50px;
      vertical-align: middle;
    }
    span {
      margin-left: 10px;
    }
  }
  p {
    margin-top: 10px;
  }
}
.crm-import-dialog .el-dialog {
  margin-top: 18vh;
  .el-form {
    padding: 0 50px 0 130px;
    font-size: 14px;
    .el-form-item {
      margin-bottom: 5px;
    }
    .el-form-item__label {
      color: #6b6b6b !important;
      padding-bottom: 0;
    }
    .el-form-item__content {
      color: #6b6b6b;
      padding-left: 15px;
    }
    .el-select {
      margin-top: 15px;
    }
  }
}
.crm-import-result-dialog .el-dialog {
  margin-top: 25vh !important;
  .el-dialog__header {
    display: none;
  }
}
.crm-form-select .el-form-item__error {
  left: 15px;
}
.crm-form-file.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  display: none;
}
.crm-form-file .el-form-item__error {
  left: 340px;
  top: 17px;
}
</style>
<style scoped>
.crm-import-dialog-form {
  text-align: left;
}
</style>
